// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3BsOm","title":"FrontImage_title__2eTnZ"};